import { createAction } from 'redux-actions'
import Api from '../Api'

export const REQUEST_DASHBOARD = createAction('REQUEST_DASHBOARD')
export const RECEIVE_DASHBOARD = createAction('RECEIVE_DASHBOARD', list => list)

export const fetchDashboard = () => {
  return (dispatch) => {
    dispatch(REQUEST_DASHBOARD())

    return dispatch(RECEIVE_DASHBOARD(Api.getDashboard()))
  }
}



// WEBPACK FOOTER //
// ./src/actions/dashboard.js